import {
  buildSelectOption,
  canShareNative,
  clearValue,
  downloadFromLink,
  getCurrentLocale,
  getDocumentDownloadByLanguage,
  getInitials,
  getPayloadDate,
  getSignaturePayLoadValue,
} from '@chekin/shared/guest-form';
import {checkIfCurrentDayBetween} from '@chekin/shared/remote-access';
import {getFirstName} from '@chekin/shared/taxes';
import dayjs from 'dayjs';
import {toastResponseError} from '@chekin/shared';

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

function goToExternalLink(url: string) {
  const isSwitched = window.open(url, '_blank');

  if (!isSwitched) {
    const anchorLink = document.createElement('a');
    anchorLink.href = url;
    anchorLink.target = '_blank';
    anchorLink.click();
    anchorLink.remove();
  }
}

function toStripeAmount(value?: string | number | null) {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (numericValue === undefined || numericValue === null || isNaN(numericValue)) {
    return 0;
  }

  return Math.round(numericValue * 100);
}

function getAge(birthDate: string) {
  return dayjs().diff(dayjs(birthDate), 'year');
}

function isAdult(birthDate: string) {
  return getAge(birthDate) >= 18;
}

function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export {
  clearValue,
  isBrowser,
  canShareNative,
  getSignaturePayLoadValue,
  getPayloadDate,
  downloadFromLink,
  getCurrentLocale,
  getDocumentDownloadByLanguage,
  checkIfCurrentDayBetween,
  toStripeAmount,
  goToExternalLink,
  toastResponseError,
  buildSelectOption,
  isAdult,
  getAge,
  shuffleArray,
  getInitials,
  getFirstName,
};
